import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {HomeworkResponse, HomeworkResponseData} from "../../types/homework/HomeworkAnswerSchema";



interface HomeworkState {
    data: HomeworkResponseData;
    success: boolean;
    isLoading: boolean;
}

const initialState: HomeworkState = {
    data: {} as HomeworkResponseData,
    success: false,
    isLoading: true,
};


const homeWorkTeacherSlice = createSlice({
    name: "homework",
    initialState,
    reducers: {
        setHomeworkResponse: (state, action: PayloadAction<HomeworkResponse>) => {
            state.data = action.payload.data
            state.success = true;
            state.isLoading = false;
        },
        clearHomeworkResponse: (state) => {
            state.success = false;
            state.data = { ...initialState.data };
        },
    },
});

export const { setHomeworkResponse, clearHomeworkResponse } = homeWorkTeacherSlice.actions;
export const homeWorkTeacherReducer = homeWorkTeacherSlice.reducer;

